module.exports = __webpack_public_path__ + "img/Human_symbol_5.3aaa81d4.png";